export default "__VITE_ASSET__OE2Wi$Pe__"